export default __webpack_public_path__ + "static/media/grunwald.19ae3979.jpg";